<template>
  <div>
    <generic-container
      :title="$t('clothing meassurements')"
      icon="tshirt"
      :searchable="true"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
    ></generic-container>
    <template v-for="(mdl, index) in meassurement_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./ClothingMeassurementConfigureModal";
// import MeassurementModal from "../components/ClothingMeassurementModal";

export default {
  name: "Settings",
  props: [],
  mounted() {},
  components: {
    "generic-container": GenericContainer
  },
  data() {
    return {
      configure_modal: ConfigureModal,
      meassurement_modals: []
    };
  },
  methods: {
    add() {
      // this.meassurement_modals.push(MeassurementModal);
      this.$router.push({ name: "ClothingMeassurementEdit" });
    },
    succedded() {},
    destroy() {
      this.meassurement_modals = [];
    }
  },
  computed: {}
};
</script>

<style>
.content.segment {
  padding: 0 !important;
}
</style>
